// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MG-z","hovered":"NG-z","hoverImage":"OG-z","mainImage":"PG-z","imageNoBackground":"QG-z","fullSizeImage":"RG-z"};